export default "__VITE_ASSET__CUW6H2td__"